var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AccountPortalView"},[_c('h1',[_vm._v(_vm._s(_vm.$t('account')))]),_vm._v("\n    "+_vm._s(_vm.$t('redirect'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }